import { ReactNode } from 'react';

type Tone = 'default' | 'accent' | 'tint' | 'success' | 'danger';

interface Props {
  icon: ReactNode;
  label: string;
  value: ReactNode;
  /** Small caption, or any node (pills, a progress track), under the value. */
  sub?: ReactNode;
  tone?: Tone;
  className?: string;
}

const ICON: Record<Tone, string> = {
  default: 'bg-mist text-slate',
  accent: 'bg-accent text-navy',
  tint: 'bg-accent-bg text-accent-ink',
  success: 'bg-success-bg text-success',
  danger: 'bg-danger-bg text-danger-ink',
};

/** Design `.mstat` card: coloured icon square beside a mono label, big value and a caption. */
export default function MetricCard({ icon, label, value, sub, tone = 'default', className = '' }: Props) {
  return (
    <section className={`flex items-center gap-3.5 rounded-[20px] border border-line bg-surface p-[18px] shadow-card ${className}`}>
      <span aria-hidden="true" className={`grid h-11 w-11 flex-none place-items-center rounded-[14px] ${ICON[tone]}`}>{icon}</span>
      <div className="min-w-0 flex-1">
        <p className="font-mono text-[11px] font-semibold uppercase tracking-[0.08em] text-muted">{label}</p>
        <p className="mb-1 mt-1.5 font-mono text-[28px] font-semibold leading-[1.1] tracking-[-0.03em] text-ink">{value}</p>
        {sub && <div className="text-xs text-muted">{sub}</div>}
      </div>
    </section>
  );
}
